export const calendar_check = {
	name: 'calendar-check',
	title: 'Calendar Check',
	content: `
  <path d="M12 2C7.03 2 3 6.03 3 11v1.17c-1.15.3-2 1.33-2 2.58v2.5c0 1.38 1.12 2.5 2.5 2.5h1c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-1V11c0-3.87 3.13-7 7-7s7 3.13 7 7v1.25h-1c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h1c1.38 0 2.5-1.12 2.5-2.5v-2.5c0-1.25-.85-2.28-2-2.58V11c0-4.97-4.03-9-9-9zM4.5 14c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5h-1c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1h1zm16 0h1c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1h-1c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5z" stroke="currentColor" fill="currentColor" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/>
	`,
};
